module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }